import React from "react"

interface HeaderProps {
    title: string,
    description: string
}
export const Header = ({ title, description }: HeaderProps) => {
    return (
        <div className="grid grid-flow-row px-6">
            <span className="text-gray-500 text-lg font-semibold">{title}</span>
            <span className="text-gray-400 text-sm">{description}</span>
        </div>

    )
}